import { on } from 'delegated-events';

const Toggle = (() => {
    const Selectors = {
        CONTAINER: '.js-toggle',
        BUTTON: '.js-toggle-button'
    };

    const ClassNames = {
        COLLAPSED: 'is-collapsed',
        EXPANDED: 'is-expanded',
        INSTANTCOLLAPSE: 'instant-collapse'
    };

    const EventLabels = {
        COLLAPSING: 'collapsing',
        EXPANDING: 'expanding'
    };

    const ButtonTexts = {
        COLLAPSE: 'Zwiń',
        EXPAND: 'Rozwiń'
    };

    const Attrs = {
        GA_LABEL: 'data-ga-label',
        TEXT: 'data-text',
        EXPAND_TEXT: 'data-expand-text',
        COLLAPSE_TEXT: 'data-collapse-text',
    };

    class Toggle {
        constructor() {
            this.addEvents(Selectors.BUTTON);
            this.instantCollapse();
        }

        handleClick(event) {
            const element = event.currentTarget;
            const closest = element.closest(Selectors.CONTAINER);
            if (closest && closest.matches(Selectors.CONTAINER)) {
                closest.classList.toggle(ClassNames.COLLAPSED);
                closest.classList.toggle(ClassNames.EXPANDED);

                setTimeout(() => {
                    const expandButtonText = element.getAttribute(Attrs.EXPAND_TEXT) || ButtonTexts.EXPAND;
                    const collapseButtonText = element.getAttribute(Attrs.COLLAPSE_TEXT) || ButtonTexts.COLLAPSE;
                    const isExpanded = element.getAttribute(Attrs.GA_LABEL) === EventLabels.EXPANDING;

                    element.setAttribute(Attrs.GA_LABEL, isExpanded ? EventLabels.COLLAPSING : EventLabels.EXPANDING);
                    element.setAttribute(Attrs.TEXT, isExpanded ? collapseButtonText : expandButtonText);
                }, 0);
            }
        }
        instantCollapse(){
            const closest = document.querySelector(Selectors.CONTAINER);

            if (closest && closest.classList.contains(ClassNames.INSTANTCOLLAPSE)){
                closest.classList.remove(ClassNames.EXPANDED);
                closest.classList.add(ClassNames.COLLAPSED);
            }
        }
        addEvents(element) {
            on('click', element, event => this.handleClick(event) );
        }
    }

    return new Toggle();

})();

export default Toggle;
